import { render, staticRenderFns } from "./LicenseOverlay.vue?vue&type=template&id=0a4cd623&scoped=true"
import script from "./LicenseOverlay.vue?vue&type=script&lang=js"
export * from "./LicenseOverlay.vue?vue&type=script&lang=js"
import style0 from "./LicenseOverlay.vue?vue&type=style&index=0&id=0a4cd623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4cd623",
  null
  
)

export default component.exports